// extracted by mini-css-extract-plugin
export default {"tabContainer":"UsersAndTeam_tabContainer__RReG3","tabLabel":"UsersAndTeam_tabLabel__jaCNe","selectedTabLabel":"UsersAndTeam_selectedTabLabel__9v6mA"};